import { useAuth } from '@/hooks/use-auth'
import { createFileRoute, Navigate, Outlet } from '@tanstack/react-router'
import { SidebarProvider } from '@/components/ui/sidebar'
import { AdminSidebar } from './-components/admin-sidebar'
import { SiteHeader } from '../_user/-components/site-header'

export const Route = createFileRoute('/_authed/admin')({
  component: AdminRoute,
  beforeLoad: () => ({
    getTitle: () => 'Admin',
  }),
})

function AdminRoute() {
  const { isSupplycoStaff, isLoading } = useAuth()

  if (isLoading) {
    return
  }

  if (!isSupplycoStaff) {
    return <Navigate to="/" />
  }

  return (
    <div className="flex h-full flex-col overflow-hidden">
      <SidebarProvider className="min-h-0! h-full! flex-1 overflow-hidden">
        <div className="flex min-h-0 flex-1 w-full overflow-hidden">
          <div className="flex-none">
            <AdminSidebar />
          </div>
          <div className="flex min-h-0 flex-1 flex-col">
            <SiteHeader />
            <main className="flex min-h-0 flex-1 flex-col gap-2 overflow-y-auto">
              <div className="flex min-h-0 flex-1 flex-col gap-4 py-4 pb-8 md:gap-6 md:py-6 md:pb-12 px-4 lg:px-6">
                <Outlet />
              </div>
            </main>
          </div>
        </div>
      </SidebarProvider>
    </div>
  )
}
